var productHref = "";
window.dataLayer = window.dataLayer || [];
var openHref = function() {
  window.top.location.href = productHref;
}
$(document).on('click', '.product-block__inner  a', function(e) {
   
    if ( (this.href.indexOf('/collections/') != -1 && this.href.indexOf('/products/') != -1) || this.href.indexOf('/products/') != -1 ) { 
  e.preventDefault();
  productHref = this.getAttribute("href");
  var attribute = productHref.split('/products/')[1];
  if(attribute.includes('?'))
    attribute = attribute.split('?')[0];
  var request = new XMLHttpRequest();
  request.open('GET', window.Shopify.routes.root + 'products/' + attribute + '.js', true);
  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      var product = JSON.parse(request.responseText);
      var productObj = {};
      productObj.item_id = String(product.id).replace("'", "").replace('"', "");
      productObj.item_name = product.title.replace("'", "").replace('"', "");
      productObj.item_brand = product.vendor.replace("'", "").replace('"', "");
      productObj.currency = window.Shopify.currency.active;
      productObj.price = product.price * 0.01;
      window.dataLayer.push({ 'ecommerce': null });
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          items: [productObj]
        }
      });
                  
      openHref();
    } else {
      // We reached our target server, but it returned an error
      openHref();
    }
  };
  request.onerror = function() {
    // There was a connection error of some sort
    openHref();
  };
  request.send();
 }     
});



